import { Router } from 'vue-router';

export const useDirectRouter = () => getActivePinia()?.router() as Router;
